
import { LoadingSpinner3D } from '@/components/LoadingSpinner3D';

/**
 * Displayed while the authentication state is being determined
 */
export const ChatAuthStateWrapper = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <LoadingSpinner3D />
    </div>
  );
};
